(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3753],{

/***/ 1292:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[slug]",
      function () {
        return __webpack_require__(1330);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);

function Loader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: "flex items-start justify-start mx-6 my-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: "w-12 h-12 ease-linear border-4 border-t-4 border-gray-200 rounded-full loader"
        })
    });
}


/***/ }),

/***/ 1330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(2918);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./lib/sanity.js
var sanity = __webpack_require__(8107);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./components/layout/header/index.js + 3 modules
var header = __webpack_require__(7821);
// EXTERNAL MODULE: ./components/layout/footer/index.js + 1 modules
var footer = __webpack_require__(8038);
// EXTERNAL MODULE: ./components/shared/preview-alert/index.js
var preview_alert = __webpack_require__(1698);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 18 modules
var format = __webpack_require__(4850);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(8420);
// EXTERNAL MODULE: ./components/content/linker/index.tsx
var linker = __webpack_require__(1056);
// EXTERNAL MODULE: ./components/content/grid/index.tsx
var grid = __webpack_require__(7533);
// EXTERNAL MODULE: ./components/layout/content-components/index.tsx + 31 modules
var content_components = __webpack_require__(3301);
// EXTERNAL MODULE: ./components/layout/footer/social-links.js
var social_links = __webpack_require__(6050);
;// CONCATENATED MODULE: ./components/layout/person/index.tsx












var ImageComponent = function(param) {
    var image = param.image, imageBlur = param.imageBlur, imageAltText = param.imageAltText, adjustedHeight = param.adjustedHeight, adjustedWidth = param.adjustedWidth, classes = param.classes;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
        src: image,
        alt: imageAltText || "",
        blurDataURL: imageBlur || "",
        placeholder: imageBlur ? "blur" : "empty",
        // layout="responsive"
        width: adjustedWidth,
        height: adjustedHeight,
        className: classes
    });
};
function Headshot(props) {
    var image = props === null || props === void 0 ? void 0 : props.image.asset;
    var alt = props.alt;
    // const { aspectRatio } = getImageDimensions(image)
    var adjustedWidth = 160;
    var adjustedHeight = 160;
    // const adjustedHeight = Math.round(adjustedWidth / aspectRatio);
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
        className: "w-24 h-24 mr-6 lg:w-40 lg:h-40 lg:mr-8",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ImageComponent, {
            image: imageScaled(image),
            imageBlur: imageBlur(image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight,
            classes: " rounded-full"
        })
    });
}
function PostImage(props) {
    var image = props === null || props === void 0 ? void 0 : props.image.asset;
    var alt = props.alt;
    // const { aspectRatio } = getImageDimensions(image)
    var adjustedWidth = 615;
    var adjustedHeight = 300;
    // const adjustedHeight = Math.round(adjustedWidth / aspectRatio);
    var imageScaled = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(adjustedWidth).height(adjustedHeight).url()) : null;
    };
    var imageBlur = function(val) {
        return val ? "".concat((0,sanity/* urlFor */.uH)(val).auto("format").width(10).url()) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ImageComponent, {
            image: imageScaled(image),
            imageBlur: imageBlur(image),
            imageAltText: alt,
            adjustedWidth: adjustedWidth,
            adjustedHeight: adjustedHeight,
            classes: "object-cover object-center w-full transition-all duration-500 lg:h-48 md:h-36 hover:scale-110"
        })
    });
}
function Layout(param) {
    var preview = param.preview, siteNav = param.siteNav, topNav = param.topNav, topFooterNav = param.topFooterNav, bottomFooterNav = param.bottomFooterNav, siteSettings = param.siteSettings, asPath = param.asPath, contentComponents = param.contentComponents, person = param.person, view = param.view;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: "flex flex-col min-h-screen",
        children: [
            preview && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(preview_alert/* PreviewAlert */.n, {
                asPath: asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* Header */.h, {
                siteNav: siteNav,
                topNav: topNav,
                siteSettings: siteSettings
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: "relative mt-6 mb-10 lg:mb-14 md:mt-7 lg:mt-8 inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "flex",
                    children: [
                        (person === null || person === void 0 ? void 0 : (ref = person.headshot) === null || ref === void 0 ? void 0 : ref.image) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Headshot, (0,_object_spread/* default */.Z)({}, person.headshot)),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "flex flex-col justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h1", {
                                    className: "mb-0 text-3xl font-extrabold lg:mb-2 lg:text-6xl",
                                    children: person === null || person === void 0 ? void 0 : person.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                    className: "text-base text-gray-600 lg:text-xl",
                                    children: person === null || person === void 0 ? void 0 : person.proTitle
                                }),
                                (person === null || person === void 0 ? void 0 : person.socialLinks) && (person === null || person === void 0 ? void 0 : person.socialLinks.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(social_links/* SocialLinks */.W, {
                                        socialLinks: person === null || person === void 0 ? void 0 : person.socialLinks
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(content_components/* ContentComponents */.W, {
                contentComponents: contentComponents,
                view: null,
                layout: true
            }),
            (person === null || person === void 0 ? void 0 : person.posts.length) >= 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "inner-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(grid/* Grid */.r, {
                    gridSize: 3,
                    children: person === null || person === void 0 ? void 0 : person.posts.map(function(post) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)("article", {
                            className: "flex flex-col mb-8 overflow-hidden rounded-md shadow-md md:mb-12 lg:mb-16",
                            children: [
                                (post === null || post === void 0 ? void 0 : post.mainImage) ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "relative flex-shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                            url: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PostImage, (0,_object_spread/* default */.Z)({}, post.mainImage))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            className: "absolute px-2 py-1 text-sm text-white bg-gray-900 rounded shadow top-4 right-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("time", {
                                                dateTime: post.publishedAt.utc,
                                                children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(post.publishedAt.utc), "MMM do, yyyy")
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "relative flex-shrink-0 overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                            url: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("figure", {
                                                className: "bg-gradient-to-r from-brand-1-800 to-brand-2-800 pt-[48.78%] w-full relative"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            className: "absolute px-2 py-1 text-sm text-white bg-gray-900 rounded shadow top-4 right-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("time", {
                                                dateTime: post.publishedAt.utc,
                                                children: (0,format/* default */.Z)((0,parseISO/* default */.Z)(post.publishedAt.utc), "MMM do, yyyy")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "flex flex-col justify-between flex-1 px-6 pt-4 pb-6 bg-white",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                        className: "flex-1",
                                        children: [
                                            (post === null || post === void 0 ? void 0 : (ref = post.category) === null || ref === void 0 ? void 0 : ref.slug) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                                className: "text-sm font-medium tracking-widest text-gray-500 uppercase title-font",
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(linker/* Linker */.h, {
                                                    url: "".concat( true ? "/blog" : 0, "/category/").concat(post.category.slug),
                                                    classes: "hover:underline",
                                                    children: post.category.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                                className: "mt-2 mb-1 text-xl font-semibold text-gray-900",
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("a", {
                                                    href: "".concat( true ? "/blog" : 0, "/").concat(post.slug),
                                                    className: "hover:underline",
                                                    children: [
                                                        "  ",
                                                        post.title
                                                    ]
                                                })
                                            }),
                                            post.summary && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                                className: "text-base text-gray-500",
                                                children: post.summary
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, post._id);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(footer/* Footer */.$, {
                siteSettings: siteSettings,
                topFooterNav: topFooterNav,
                bottomFooterNav: bottomFooterNav
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/seo/index.js
var seo = __webpack_require__(3304);
// EXTERNAL MODULE: ./components/shared/loader/index.tsx
var loader = __webpack_require__(8668);
;// CONCATENATED MODULE: ./pages/profile/[slug].js









/**
 * Helper function to return the correct version of the document
 * If we're in preview mode, it'll return the preview document
 */ function filterDataToSingleItem(data, preview) {
    if (!Array.isArray(data)) {
        return data;
    }
    if (data.length === 1) {
        return data[0];
    }
    if (preview) {
        return data.find(function(item) {
            return item._id.startsWith("drafts.");
        }) || data[0];
    }
    return data[0];
}
var __N_SSG = true;
/**
 * The `usePreviewSubscription` takes care of updating
 * the preview content on the client-side
 */ function Page(param) {
    var data = param.data, preview = param.preview;
    var ref, ref1;
    var asPath = (0,next_router.useRouter)().asPath;
    var ref2;
    var ref3 = (0,sanity/* usePreviewSubscription */.$r)(data === null || data === void 0 ? void 0 : data.query, {
        params: (ref2 = data === null || data === void 0 ? void 0 : data.queryParams) !== null && ref2 !== void 0 ? ref2 : {},
        // The hook needs to know what we started with, to return it immediately
        // This is what it's important to fetch draft content server-side!
        initialData: data === null || data === void 0 ? void 0 : data.page,
        // The passed-down preview context determines whether this function does anything
        enabled: preview
    }), previewData = ref3.data;
    var page = filterDataToSingleItem(previewData, preview);
    // Notice the optional?.chaining conditionals wrapping every piece of content. This is extremely important as you can't ever rely on a single field of data existing when Editors are creating new documents. It'll be completely blank when they start!
    var superPage = (page === null || page === void 0 ? void 0 : page.superPages[0]) || null;
    var siteSettings = (page === null || page === void 0 ? void 0 : page.siteSettings) || null;
    var siteNav = (page === null || page === void 0 ? void 0 : page.siteNav) || null;
    var topNav = (page === null || page === void 0 ? void 0 : page.topNav) || null;
    var topFooterNav = (page === null || page === void 0 ? void 0 : page.topFooterNav) || null;
    var bottomFooterNav = (page === null || page === void 0 ? void 0 : page.bottomFooterNav) || null;
    var contentComponents = ((ref = page === null || page === void 0 ? void 0 : page.superPages[0]) === null || ref === void 0 ? void 0 : ref.contentComponents) || null;
    var posts = ((ref1 = page === null || page === void 0 ? void 0 : page.superPages[0]) === null || ref1 === void 0 ? void 0 : ref1.posts) || [];
    var blog = {
        "posts": (0,_to_consumable_array/* default */.Z)(posts)
    };
    var router = (0,next_router.useRouter)();
    if (!router.isFallback && !(superPage === null || superPage === void 0 ? void 0 : superPage.slug)) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(error["default"], {
            statusCode: 404
        });
    }
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(loader/* Loader */.a, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(seo/* SEO */.H, {
                page: superPage,
                site: siteSettings,
                path: asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Layout, {
                preview: preview,
                asPath: asPath,
                siteNav: siteNav,
                topNav: topNav,
                topFooterNav: topFooterNav,
                bottomFooterNav: bottomFooterNav,
                siteSettings: siteSettings,
                contentComponents: contentComponents,
                person: superPage,
                view: blog
            })
        ]
    });
}


/***/ }),

/***/ 2918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(9185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6914,6556,7505,3090,8348,8857,9774,2888,179], function() { return __webpack_exec__(1292); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);